/** The subject of a reply, as the composer writes it: `prefix` ("Re :") before it, unless it is one already. */
const replySubject = (subject: string, prefix: string): string =>
    /^re ?:/i.test(subject) ? subject : `${prefix} ${subject}`;

export default replySubject;
